import React from 'react';
import { IMaskInput } from 'react-imask';
import styled from 'styled-components';
import InputStyles from './InputStyles';

interface IDOBInputProps {
  type?: string;
  disabled?: boolean;
  id?: string;
  placeholder?: string;
  onBlur?: (e: Event) => void;
  onChange?: (e: Event) => void;
  value?: string;
}

interface IMask {
  mask: string;
}

const StyledImaskInput = styled(IMaskInput).attrs({
  inputMode: 'numeric',
})`
  ${InputStyles}
`;

const defaultDOBMask: IMask[] = [{ mask: '00-00-0000' }];

const DOBInput: React.FC<IDOBInputProps> = (props) => {
  const comboMask: any = {
    mask: [...defaultDOBMask],
    unmask: true,
    lazy: false,
  };

  return <StyledImaskInput data-cy="date-of-birth-input" {...comboMask} {...props} />;
};

export default DOBInput;
